
<footer *ngIf="externalLoaded">
    <div class="container center">
        <small>{{ copyrightMessage }}</small>
    </div>
  </footer>
